// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3_V8a","ranges":"BmiRanges_ranges__1EfZI"};